import React, { useState } from "react";
import { Form, Col, Row, OverlayTrigger, Tooltip } from "react-bootstrap";
import "./InputField.css";
import {
  FaEdit,
  FaUser,
  FaEnvelope,
  FaPhone,
  FaLock,
  FaEye,
  FaEyeSlash,
  FaInfo,
  FaInfoCircle,
  FaPen,
} from "react-icons/fa";
import { FaPencil } from "react-icons/fa6";
import CitySuggestionInputField from "@/components/user/My Profile/components/CitySuggestionInputField";

const ShimmerDiv = ({ height = "38px", className = "" }) => (
  <div
    className={`inputField-form-control form-field-style ${className}`}
    style={{
      height,
      background:
        "linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%)",
      backgroundSize: "200% 100%",
      animation: "shimmerInput 1.5s infinite linear",
      border: "1px solid #e0e0e0",
      borderRadius: "0.375rem",
    }}
  />
);

const InputField = ({
  label,
  formRef,
  placeholder,
  type,
  showRightIcon = true,
  width,
  required,
  options = [],
  isEditButtonEnabled,
  onChange,
  value,
  selected,
  icon,
  name,
  error,
  onEdit,
  disabled,
  girdType,
  className,
  validateField, // Added: Validator function passed from parent
  setErrors, // Added: To update validation errors
  isSetPasswordEnabled,
  onSetPasswordClick,
  isProfileLoading,
  maxLength,
  lableStyle = {},
  handleBlur,
  showToolTip,
  forgotPwdEnabled,
  handleForgotPasswordModal,
  inputwidth = false,
  inputwidthClass,
  fieldStyle = {},
  fromBidWizard = false,
  autoComplete,
}) => {
  const [showPassword, setShowPassword] = useState(false);
  const isPassword = type === "password";

  // Get the icon dynamically based on the `icon` prop
  const getIcon = () => {
    switch (icon) {
      case "user":
        return <FaUser size={16} />;
      case "envelope":
        return <FaEnvelope size={16} />;
      case "phone":
        return <FaPhone size={16} />;
      case "lock":
        return <FaLock size={16} />;
      default:
        return null;
    }
  };

  // Handle input change with validation
  const handleChange = (e) => {
    const { name, value } = e.target;
    onChange(e); // Call the parent-provided onChange function to update state

    if (validateField) {
      const validationErrors = validateField({ [name]: value }, [name]);
      setErrors?.((prevErrors) => ({
        ...prevErrors,
        [name]: validationErrors[name] || "", // Add error if invalid or clear if valid
      }));
    }
  };

  return (
    <Form.Group
      as={girdType ? girdType : Row}
      className={`${className ? className : "mb-3"} from-reponsive-profile`}
      controlId={`form${label?.replace(/\s+/g, "")}`}
      style={{ width }}
    >
      {label ? (
        <Form.Label
          column
          xs="4"
          sm="4"
          className={required ? "input-required-label" : ""}
          style={{
            fontSize: "12px",
            textAlign: "left",
            alignSelf: "center",
            paddingBottom: "20px",
            fontFamily: "robotolight",
            fontWeight: 700,
            color: "#505050",
            ...lableStyle,
          }}
        >
          {label}
        </Form.Label>
      ) : null}
      <Col xs="8" sm="8" md={!label && "12"}>
        {type === "dropdown" ? (
          <>
            <div className="d-flex align-items-center inputField-position-relative w-100">
              <div
                className={`input-field-wrapper ${
                  name === "smsOptInStatus" ? " w-50" : "w-100"
                }`}
              >
                <div
                  className={`${
                    inputwidth
                      ? `${inputwidthClass || "w-50"}`
                      : "inputField-input-group"
                  } position-relative`}
                >
                  {isProfileLoading ? (
                    <ShimmerDiv />
                  ) : (
                    <Form.Select
                      // as="select"
                      ref={(el) => {
                        if (formRef && formRef?.current && name) {
                          formRef.current[name] = el;
                        }
                      }}
                      required={required}
                      disabled={disabled}
                      onChange={handleChange}
                      value={isProfileLoading ? " " : value || ""}
                      name={name}
                      isInvalid={!!error}
                      className="inputField-form-control form-field-style"
                      style={fieldStyle}
                    >
                      <option value="" disabled>
                        {placeholder}
                      </option>
                      {options.map((option, index) => (
                        <option
                          key={index}
                          value={
                            typeof option === "object" ? option.value : option
                          }
                        >
                          {typeof option === "object" ? option.label : option}
                        </option>
                      ))}
                    </Form.Select>
                  )}
                  {/* <div
                    style={{
                      position: "absolute",
                      right: "10px",
                      top: "50%",
                      transform: "translateY(-50%)",
                      pointerEvents: "none",
                    }}
                  >
                    <i className="bi bi-chevron-down"></i>
                  </div> */}
                </div>
                {error && (
                  <div
                    className="input-field-errors"
                    style={{
                      fontFamily: "robotolight",
                    }}
                  >
                    {error}
                  </div>
                )}
              </div>
            </div>
          </>
        ) : type === "radio" || type === "checkbox" ? (
          <div className="d-flex align-items-center mt-1">
            <div className="form-check form-check-inline p-0">
              {options?.map((option, index) => (
                <div
                  key={option.value}
                  className="radio-wrapper form-check form-check-inline me-4"
                  style={{
                    fontFamily: "robotomedium",
                  }}
                >
                  <input
                    disabled={disabled}
                    className={`form-check-input mt-1 ${error ? "is-invalid" : ""}`}
                    type={type}
                    id={`${name}_${option.value}`}
                    name={name}
                    value={option.value}
                    tabIndex={0}
                    ref={(el) => {
                      if (formRef && formRef?.current && name && index === 0) {
                        formRef.current[name] = el;
                      }
                    }}
                    checked={
                      type === "radio"
                        ? selected === option.value
                        : value?.includes?.(option.value) ||
                          value === option.value
                    }
                    onChange={handleChange}
                    style={{
                      outline: 'none',
                    }}
                    onFocus={(e) => {
                      e.target.style.boxShadow = '0 0 0 1px #007bff';
                    }}
                    onBlur={(e) => {
                      e.target.style.boxShadow = 'none';
                      e.target.style.outline = 'none';
                    }}
                  />
                  <label
                    className="form-check-label mt-1"
                    htmlFor={`${name}_${option.value}`}
                    style={{
                      cursor: 'pointer',
                      userSelect: 'none'
                    }}
                  >
                    {option.label}
                  </label>
                </div>
              ))}
            </div>
            {error && (
              <div
                className="input-field-errors"
                style={{
                  fontFamily: "robotolight",
                }}
              >
                {error}
              </div>
            )}
          </div>
        ) : name === "city" ? (
          <div className="inputField-position-relative">
            <div className="d-flex align-items-center inputField-position-relative">
              <div className="input-field-wrapper" style={{ minWidth: "100%" }}>
                <div
                  className={`${
                    inputwidth
                      ? `${inputwidthClass || "w-50"}`
                      : "inputField-input-group"
                  }`}
                >
                  {isProfileLoading ? (
                    <ShimmerDiv />
                  ) : (
                    <CitySuggestionInputField
                      name={name}
                      type={type}
                      placeholder={placeholder}
                      value={value}
                      onChange={handleChange}
                      required={required}
                      className={`flex-grow-1 form-field-style ${
                        error ? "is-invalid" : ""
                      }`}
                      suggestions={options}
                      onBlur={handleBlur}
                      isProfileLoading={isProfileLoading}
                      inputRef={formRef}
                    />
                  )}
                </div>
                {error && (
                  <div
                    className="input-field-errors"
                    style={{
                      fontFamily: "robotolight",
                    }}
                  >
                    {error}
                  </div>
                )}
              </div>
            </div>
          </div>
        ) : (
          <div className="inputField-position-relative">
            <div className="d-flex align-items-center inputField-position-relative">
              <div className="input-field-wrapper" style={{ minWidth: "100%" }}>
                <div
                  className={`${
                    inputwidth
                      ? `${inputwidthClass || "w-50"}`
                      : "inputField-input-group"
                  }`}
                >
                  {isProfileLoading ? (
                    <ShimmerDiv />
                  ) : (
                    <Form.Control
                      name={name}
                      type={
                        isPassword ? (showPassword ? "text" : "password") : type
                      }
                      ref={(el) => {
                        if (formRef && formRef?.current && name) {
                          formRef.current[name] = el;
                        }
                      }}
                      maxLength={maxLength}
                      placeholder={placeholder}
                      required={required}
                      disabled={disabled}
                      className={`flex-grow-1 form-field-style ${
                        error ? "is-invalid" : ""
                      }`}
                      value={isProfileLoading ? " " : value || ""}
                      onChange={handleChange}
                      isInvalid={!!error}
                      style={{
                        backgroundColor: `${disabled ? "#EEEEEE" : ""}`,
                        paddingRight: isPassword ? "40px" : "10px",
                        ...fieldStyle,
                      }}
                      aria-busy={isProfileLoading}
                      aria-label={name}
                      onBlur={handleBlur}
                      autoComplete={
                        autoComplete ?? (isPassword ? "off" : "new-password")
                      }
                    />
                  )}

                  {isPassword &&
                    !showToolTip &&
                    !forgotPwdEnabled &&
                    showRightIcon && (
                      <div
                        className="inputField-eye-icon"
                        // onClick={() => setShowPassword(!showPassword)}
                        style={{
                          position: "absolute",
                          right: isEditButtonEnabled ? "45px" : "10px",
                          top: "50%",
                          transform: "translateY(-50%)",
                          cursor: "pointer",
                          zIndex: 10,
                          color: "#6c757d",
                        }}
                      >
                        {showPassword ? (
                          <FaEye size={20} />
                        ) : (
                          <FaEyeSlash size={20} />
                        )}
                      </div>
                    )}

                  {isPassword && showToolTip && (
                    <OverlayTrigger
                      placement="bottom"
                      overlay={
                        <Tooltip
                          id="password-tooltip"
                          className="custom-tooltip"
                        >
                          Password should be 8 or more in length with at least
                          one number, special character(! # @ % $ ; ^) and
                          uppercase letter.
                        </Tooltip>
                      }
                    >
                      <div
                        className="inputField-eye-icon"
                        onClick={() => setShowPassword(!showPassword)}
                        style={{
                          position: "absolute",
                          right: isEditButtonEnabled ? "45px" : "10px",
                          top: "50%",
                          transform: "translateY(-50%)",
                          cursor: "pointer",
                          zIndex: 10,
                          color: "#6c757d",
                        }}
                      >
                        <FaInfoCircle />
                      </div>
                    </OverlayTrigger>
                  )}

                  {isPassword && forgotPwdEnabled && (
                    <OverlayTrigger
                      placement="bottom"
                      overlay={
                        <Tooltip
                          id="password-tooltip"
                          className="custom-tooltip"
                        >
                          Forgot password
                        </Tooltip>
                      }
                    >
                      <div
                        className="inputField-eye-icon"
                        onClick={handleForgotPasswordModal}
                        style={{
                          cursor: "pointer",
                          fontSize: 12,
                          zIndex: 10,
                          fontFamily: "robotobold",
                          color: "#A6A6A6",
                        }}
                      >
                        FORGOT?
                      </div>
                    </OverlayTrigger>
                  )}

                  {isEditButtonEnabled && name !== "emailId" && (
                    <button
                      className="inputField-edit-button"
                      onClick={onEdit}
                      disabled={
                        isEditButtonEnabled ? !isEditButtonEnabled : disabled
                      }
                    >
                      <FaPencil size={16} color="#000" />
                      <span className="fa-edit-text">Edit</span>
                    </button>
                  )}
                </div>

                {error && (
                  <div
                    className="input-field-errors"
                    style={{
                      fontFamily: "robotolight",
                    }}
                  >
                    {error}
                  </div>
                )}

                {name === "emailId" &&
                  !isSetPasswordEnabled &&
                  !fromBidWizard && (
                    <p
                      className="chnage-email-pro"
                      style={{
                        fontSize: "12px",
                        fontFamily: "robotolight",
                        cursor: "pointer",
                      }}
                      onClick={onEdit}
                    >
                      Change Email
                    </p>
                  )}
              </div>

              {name === "emailId" && isSetPasswordEnabled && (
                <p
                  style={{
                    fontSize: "14px",
                    color: "#333",
                    fontFamily: "robotolight",
                    marginLeft: "1.5rem",
                    minWidth: "100%",
                  }}
                >
                  Click{" "}
                  <span
                    onClick={onSetPasswordClick}
                    style={{ color: "#428bca", cursor: "pointer" }}
                  >
                    here
                  </span>{" "}
                  to go to 'Account Settings' and set a password.
                </p>
              )}
            </div>
            {/* {error && (
              <Form.Control.Feedback type="invalid" style={{ display: "block" }}>
                {error}
              </Form.Control.Feedback>
            )} */}
          </div>
        )}
      </Col>
    </Form.Group>
  );
};

export default InputField;
